// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import 'es6-promise/auto'
import jQuery from 'jquery'
import Vue from 'vue'
import App from './App'
import router from './router'
import moment from 'moment'
import Notifications from 'vue-notification'
import { store } from './store/store'
import Icon from './icon.vue'
import numeral from 'numeral'
import 'numeral/locales'
require('vue-multiselect/dist/vue-multiselect.min.css')
var VueCookie = require('vue-cookie')
Vue.use(VueCookie)

Es6Promise.polyfill()

require('foundation-sites')
window.jQuery = jQuery
window.$ = jQuery

// numeral
numeral.locale('da-dk')
window.numeral = numeral

window.MotionUI = require('motion-ui')
Vue.component('icon', Icon)

// Moment
window['moment'] = moment
moment.locale('da')

// Notifications
Vue.use(Notifications)

// Filters
Vue.prototype.$filters = Vue.options.filters // So we can acces the filters in js
Vue.filter('formatDate', function (date) {
    if (date) {
        if (date === 'Ingen dato') {
            return date
        } else {
            let now = moment(new Date())
            let yesterday = moment().subtract(1, 'day')
            let dayBeforeYesterday = moment().subtract(2, 'day')
            if (moment(date).isSame(now, 'day')) {
                return 'I dag'
            } else if (moment(date).isSame(yesterday, 'day')) {
                return 'I går'
            } else if (moment(date).isSame(dayBeforeYesterday, 'day')) {
                return 'I forgårs'
            } else if (moment(date).isSame(now, 'week')) {
                return 'I ' + window['moment'].utc(date).format('dddd[s]')
            } else {
                return window['moment'].utc(date).format('DD[.] MMMM YYYY')
            }
        }
    } else {
        return 'Ingen dato'
    }
})
Vue.filter('formatDateShort', function (date) {
    if (date && date !== 'Ingen dato') {
        return window['moment'].utc(date).format('DD[.] MMM YYYY')
    } else {
        return 'Ingen dato'
    }
})
Vue.filter('formatDateWithTimeStandard', function (date) {
    return window['moment'].utc(date).format('DD[.] MMMM YYYY')
})
Vue.filter('formatDateWithTime', function (date) {
    return window['moment'].utc(date).format('DD[.] MMMM YYYY[,] [kl.] HH[.]mm')
})
Vue.filter('formatTime', function (time) {
    return window['moment'].utc(time).format('[kl.] HH[.]mm')
})
Vue.filter('toLowerCase', function (string) {
    return string.toLowerCase()
})

Vue.filter('translateToDanish', function (text) {
    let label = ''
    switch (text) {
    case 'projects':
        label = 'Projekter'
        break

    case 'reports':
        label = 'Rapporter'
        break

    case 'jobs':
        label = 'Jobs'
        break

    case 'new':
        label = 'ny'
        break

    case 'imported':
        label = 'import'
        break

    case 'matched':
        label = 'matched'
        break

    case 'activated':
        label = 'aktiv'
        break

    case 'fiction':
        label = 'fiktiv'
        break

    case 'no-affiliation':
        label = 'Intet tilhørsforhold'
        break
    }
    return label !== '' ? label : text
})

Vue.filter('translateAssetRegister', function (id) {
    let asset = ''
    switch (id) {
    case '3649027A-370E-44DF-84C4-238D652489D3':
        asset = 'DANDAS'
        break

    case '3645027A-340E-44DF-83C4-238D652489D3':
        asset = 'ASSET'
        break

    case '4645027A-340E-44DF-83C4-238D652489D3':
        asset = 'ASSET'
        break

    default:
        asset = 'Intet tilhørsforhold'
        break
    }
    return asset
})

Vue.filter('translateProjectStatusCode', function (statusCode) {
    let status = ''
    switch (statusCode) {
    case 1:
        status = 'ny'
        break
    case 2:
        status = 'importeret'
        break
    case 3:
        status = 'matched'
        break
    case 4:
        status = 'help'
        break
    case 5:
        status = 'aktiveret'
        break

    default:
        status = 'fiction'
        break
    }
    return status
})

Vue.filter('translateImportAktivTypeToIcon', function (aktivType, forceIcon) {
    let icon = 'missingIcon'
    // Kun spildevand for nu \\
    // Type af aktiv
    if (aktivType.importAktivTypeKode === 1) {
        icon = 'knude'
    } else if (aktivType.importAktivTypeKode === 2) {
        icon = 'ledning'
    }
    // Type af kode
    // Force icon means that under "tekniske ændringer",
    // we always want to show the icon for "tekniske ændring" e.g. ImportTypeKode(3 or 4)
    if (forceIcon === 3) {
        icon += 'samle'
    } else if (aktivType.importAktivTypeKode === 6) {
        // Asset
        icon = 'knudetilgang'
    } else {
        if (aktivType.importMatch === null && aktivType.samle !== 1 && aktivType.erstat !== 1) {
            icon += 'tilgang'
        } else if (aktivType.importMatch !== null && aktivType.afgang !== 1 && aktivType.samle !== 1 && aktivType.erstat !== 1 && aktivType.stikErstat !== 1) {
            icon += 'aendring'
        } else if (aktivType.importMatch !== null && aktivType.afgang === 1 && aktivType.samle !== 1 && aktivType.erstat !== 1 && aktivType.stikErstat !== 1) {
            icon += 'afgang'
        } else if (aktivType.erstat === 1) {
            icon += 'erstat'
        } else if (aktivType.samle === 1) {
            icon += 'samle'
        }
        // if (aktivType.importTypeKode === 1) {
        //     icon += 'tilgang' - done
        // } else if (aktivType.afgang === 1) {
        //     icon += 'afgang' - done
        // } else if (aktivType.importTypeKode === 2) {
        //     icon += 'aendring' - done
        // } else if (aktivType.importTypeKode === 3) {
        //     icon += 'samle'
        // } else if (aktivType.importTypeKode === 4) {
        //     icon += 'erstat'
        // }
    }

    return icon
})

Vue.filter('translateImportAktivType', function (aktivTypeKode) {
    let title = 'Ingen type'
    // Kun spildevand for nu \\
    // Type af aktiv
    if (aktivTypeKode === 1) {
        title = 'Knude'
    } else if (aktivTypeKode === 2) {
        title = 'Ledning'
    }

    return title
})

Vue.filter('translateLogTypeToIcon', function (logType) {
    let icon = 'missingIcon'
    // Kun spildevand for nu \\
    // Type af aktiv
    switch (logType) {
    case 1:
        icon = 'ledning'
        break
    case 2:
        icon = 'ledningaendring'
        break
    case 3:
        icon = 'ledningafgang'
        break
    case 4:
        icon = 'knude'
        break
    case 5:
        icon = 'knudeaendring'
        break
    case 6:
        icon = 'knudeafgang'
        break
    }
    return icon
})

// Vue.filter('convertToLocalStringDK', function (number) {
//     return number.toLocaleString('da-DK')
// })

Vue.filter('convertToLocalStringDK', function (number) {
    if (number !== null && number !== undefined) {
        let value = number.toString()
        let commaIndex = value.indexOf(',')
        let displayResult = ''
        // Tror ikke denne bliver nødvendig
        if (commaIndex > -1) {
            // Decimals
            let decimals = value.substring(commaIndex + 1, commaIndex + 4)
            // Round up
            decimals = Number('0.' + decimals).toFixed(2).substring(2, 4)
            // Numbers
            let numbers = value.substring(0, commaIndex)
            // Result for display
            displayResult = new Intl.NumberFormat('da-DK').format(numbers) + ',' + decimals
        } else {
            displayResult = new Intl.NumberFormat('da-DK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value)
        }
        if (displayResult.toLowerCase() === 'nan') {
            displayResult = 'ugyldig værdi'
        }
        return displayResult
    }
    return ''
})

Vue.filter('convertToNumber', function (value) {
    if (isNaN(value) || typeof value === 'string') {
        value = parseFloat(value.replace(',', '.').replace(' ', ''))
    }
    return value
})

Vue.filter('shortenStatusDescription', function (value) {
    if (value === 'Sat til aktivering') {
        value = 'Aktivering'
    }
    if (value === 'Aktiveret med fiktive aktiver') {
        value = 'Fiktiv'
    }
    return value
})

Vue.config.productionTip = false

/* eslint-disable no-new */
const app = new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: {
        App
    }
})

window.$(document).foundation()
router.beforeEach((to, from, next) => {
    app.$store.commit('setRouterHistory', from.name)
    next()
})



// WEBPACK FOOTER //
// ./src/main.js